import { VisitorVariations } from '@src/container/handleIframeMessage/types';
import { FS_FORCED_VARIATIONS } from '../constants';
import { FsVariationToForce } from '../type';

export function saveForcedVariations(variationsToForce: Record<string, FsVariationToForce>): void {
  const sessionForcedVariations = sessionStorage.getItem(FS_FORCED_VARIATIONS);
  let forcedVariations: Record<string, FsVariationToForce> = {};
  try {
    forcedVariations = JSON.parse(sessionForcedVariations || '{}');
  } catch (error) {
    console.error('Error parsing sessionForcedVariations', error);
  }
  forcedVariations = { ...forcedVariations, ...variationsToForce };
  sessionStorage.setItem(FS_FORCED_VARIATIONS, JSON.stringify(forcedVariations));
}

export function getForcedVariationsFromStorage(): Record<string, FsVariationToForce> {
  let forcedVariations: Record<string, FsVariationToForce> = {};
  const sessionForcedVariations = sessionStorage.getItem(FS_FORCED_VARIATIONS);
  try {
    forcedVariations = JSON.parse(sessionForcedVariations || '{}');
  } catch (error) {
    console.error('Error parsing sessionForcedVariations', error);
  }
  return forcedVariations;
}

export function removeForcedVariationsInStorage(): void {
  sessionStorage.removeItem(FS_FORCED_VARIATIONS);
}

export function validateVariationType(data: Record<string, VisitorVariations>): boolean {
  return (
    typeof data === 'object' &&
    Object.values(data).every((campaign) => {
      return (
        typeof campaign === 'object' &&
        typeof campaign.variationId === 'string' &&
        typeof campaign.variationGroupId === 'string' &&
        typeof campaign.campaignId === 'string'
      );
    })
  );
}
